import {
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
} from '@mui/material';
import React from 'react';

const compactSx = {
  fontFamily: "'Nunito', sans-serif",
  lineHeight: 1.35,
  margin: 0,
};

export interface MobileTypographyProps
  extends Omit<MuiTypographyProps, 'variant'> {
  variant?: MuiTypographyProps['variant'];
}

const mergeSx = (base: object, override?: MuiTypographyProps['sx']) =>
  override ? [base, override] : base;

export const MobileTitle: React.FC<MobileTypographyProps> = ({
  sx,
  ...props
}) => (
  <MuiTypography
    variant="h1"
    {...props}
    sx={mergeSx(
      {
        ...compactSx,
        fontSize: '1.375rem',
        fontWeight: 700,
        letterSpacing: '-0.01em',
      },
      sx,
    )}
  />
);

export const MobileSubtitle: React.FC<MobileTypographyProps> = ({
  sx,
  ...props
}) => (
  <MuiTypography
    variant="h2"
    {...props}
    sx={mergeSx({ ...compactSx, fontSize: '1.125rem', fontWeight: 700 }, sx)}
  />
);

export const MobileBody: React.FC<MobileTypographyProps> = ({
  sx,
  ...props
}) => (
  <MuiTypography
    variant="body1"
    {...props}
    sx={mergeSx({ ...compactSx, fontSize: '0.9375rem', fontWeight: 500 }, sx)}
  />
);

export const MobileBody2: React.FC<MobileTypographyProps> = ({
  sx,
  ...props
}) => (
  <MuiTypography
    variant="body2"
    {...props}
    sx={mergeSx({ ...compactSx, fontSize: '0.875rem', fontWeight: 500 }, sx)}
  />
);

export const MobileCaption: React.FC<MobileTypographyProps> = ({
  sx,
  ...props
}) => (
  <MuiTypography
    variant="caption"
    {...props}
    sx={mergeSx({ ...compactSx, fontSize: '0.8125rem', fontWeight: 500 }, sx)}
  />
);

export const MobileLabel: React.FC<MobileTypographyProps> = ({
  sx,
  ...props
}) => (
  <MuiTypography
    variant="subtitle2"
    {...props}
    sx={mergeSx({ ...compactSx, fontSize: '0.8125rem', fontWeight: 700 }, sx)}
  />
);

export const MobileOverline: React.FC<MobileTypographyProps> = ({
  sx,
  ...props
}) => (
  <MuiTypography
    variant="overline"
    {...props}
    sx={mergeSx(
      {
        ...compactSx,
        fontSize: '0.75rem',
        fontWeight: 700,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
      },
      sx,
    )}
  />
);
